export const GET_PROVIDER_DATA = "GET_PROVIDER_DATA";
export const SELECT_TABLE_DATA = "SELECT_TABLE_DATA";
export const GET_PROVIDER_DROPDOWN = "GET_PROVIDER_DROPDOWN";
export const GET_COMMON_DATA = "GET_COMMON_DATA";
export const GET_DETAIL_DATA = "GET_DETAIL_DATA";
export const GET_PROVIDER_LIST = "GET_PROVIDER_LIST";
export const GET_NDC_GRID_DETAIL = "GET_NDC_GRID_DETAIL";
export const GET_PROVIDER_FROZEN_COMPLETE = "GET_PROVIDER_FROZEN_COMPLETE";
export const GET_PROVIDER_REVIEW_CLAIM_HEADER =
  "GET_PROVIDER_REVIEW_CLAIM_HEADER";
export const GET_CORRECTION_CODE_DROPDOWN = "GET_CORRECTION_CODE_DROPDOWN";
export const GET_PROBLEM_CODE_DROPDOWN = "GET_PROBLEM_CODE_DROPDOWN";
export const HANDLE_ERROR_MSG = "HANDLE_ERROR_MSG";
export const ROW_SELECTED = "ROW_SELECTED";
export const GET_PROBLEMCODE = "GET_PROBLEMCODE";
export const GET_CORRECTIONCODE = "GET_CORRECTIONCODE";
export const BUTTON_STATE="BUTTON_STATE";
